import * as React from 'react';
import { Box, Text, Image } from '@wix/design-system';
import { Trans } from 'react-i18next';
import WarningLossFeaturesIcon from '../../../../../../assets/images/change-plan/downgrade-warning.svg?url';

export const DowngradeWarning = () => (
  <Box
    direction='horizontal'
    gap='SP1'
    marginTop='SP2'
    dataHook='downgrade-warning'
  >
    <Box minWidth='12px' height='13px' paddingTop='2px'>
      <Image src={WarningLossFeaturesIcon} transparent borderRadius='0px' />
    </Box>
    <Text size='small'>
      <Trans i18nKey='premium.purchase-plan.downgrade-plan.warning' />
    </Text>
  </Box>
);
